export default __webpack_public_path__ + "static/halfpattern-670231985659d316bfd5fc6b9bf4f962.png";